import { use } from "react";
import { useDbClient, useLiveQuery } from "@tanstack/react-db";
import {
  QueryViewerContext,
  collectionError,
  refreshCollections,
} from "@softmax/web-features/data";
import { ApiError } from "@softmax/observatory-client/transport";
import { myUsageStatusCollection } from "@/features/usage/records";
import joinedStyles from "../account-pill.module.css";

export function AccountCreditBalance() {
  const viewerId = use(QueryViewerContext);
  const dbClient = useDbClient();
  const descriptor = myUsageStatusCollection({
    viewerId,
    elevatedPrivileges: false,
  });
  const query = useLiveQuery((q) => q.from({ status: descriptor }).findOne());
  const error = collectionError(query.health);
  const unavailable =
    error instanceof ApiError && (error.status === 401 || error.status === 403);
  const balance = unavailable ? undefined : query.data?.credits.balance_credits;
  let label = "Loading credits…";

  if (balance !== undefined)
    label = `${balance.toLocaleString("en-US")} credits left`;
  else if (error) label = "Credits unavailable";

  return (
    <li className={joinedStyles.credits}>
      {label}
      {error && (
        <button
          type="button"
          className={joinedStyles.item}
          onClick={() => {
            void refreshCollections({
              signal:
                dbClient.requireDependency<AbortController>("lifetime").signal,
              queries: [query.collection],
              refresh: () =>
                dbClient
                  .collection(descriptor)
                  .utils.refetch({ throwOnError: true }),
            });
          }}
        >
          Retry credits
        </button>
      )}
    </li>
  );
}
